import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useIsAuthenticate from "../hooks/useIsAuthenticate";

export function PrivateRoute({ component, ...rest }) {
  const { isAuthenticate } = useIsAuthenticate();
  return isAuthenticate ? <Outlet /> : <Navigate to="/" />;
}
